<template>
  <div class="titre_introduction">
    <div class="bloc_introductif">
      <h1 v-if="route.name === 'accueil'" class="titre_introduction">Mes transports scolaires</h1>

      <h2 v-if="route.name === 'reinscription-scolaire'" class="sous_titre_introduction">
        Réinscription pour l'année 2026 - 2027
      </h2>

      <h2 v-if="route.name === 'formulaire-cas-1'" class="sous_titre_introduction">
        Formulaire d'inscription Maternelle / Primaire
      </h2>

      <h2 v-if="route.name === 'formulaire-cas-2'" class="sous_titre_introduction">
        Formulaire d'inscription Collège/Lycée de la CC des Terres Touloises
      </h2>

      <h2 v-if="route.name === 'formulaire-cas-3'" class="sous_titre_introduction">
        Formulaire d'inscription Collège/Lycée hors de la CC des Terres Touloises
      </h2>

      <h2 v-if="route.name === 'reinscription-formulaire-cas-1'" class="sous_titre_introduction">
        Formulaire de réinscription Maternelle / Primaire
      </h2>

      <h2 v-if="route.name === 'reinscription-formulaire-cas-2'" class="sous_titre_introduction">
        Formulaire de réinscription Collège/Lycée de la CC des Terres Touloises
      </h2>

      <h2 v-if="route.name === 'reinscription-formulaire-cas-3'" class="sous_titre_introduction">
        Formulaire de réinscription Collège/Lycée hors de la CC des Terres Touloises
      </h2>
    </div>

    <h3 v-if="route.name === 'formulaire-cas-1'" class="texte_introduction">
      Ce formulaire vous permet de faire une demande de transport scolaire pour votre enfant scolarisé de la
      petite section au CM2.
    </h3>

    <h3 v-if="route.name === 'reinscription-formulaire-cas-1'" class="texte_introduction">
      Ce formulaire vous permet de renouveler votre demande de transport scolaire pour votre enfant scolarisé de la
      petite section au CM2.
    </h3>

    <h3 v-if="route.name === 'formulaire-cas-2'" class="texte_introduction">
      Ce formulaire vous permet de faire une demande de transport scolaire pour votre enfant scolarisé de la 6ème
      à la terminale.<br /><br />Merci de vous munir d'une photo d'identité récente de votre enfant.
    </h3>

    <h3 v-if="route.name === 'reinscription-formulaire-cas-2'" class="texte_introduction">
      Ce formulaire vous permet de faire une demande de transport scolaire pour votre enfant scolarisé de la 6ème
      à la terminale.
    </h3>

    <h3 v-if="route.name === 'formulaire-cas-3'" class="texte_introduction">
      Ce formulaire vous permet de faire une demande de transport scolaire pour votre enfant scolarisé de la 6ème
      à la terminale.<br /><br />Merci de vous munir d'une photo d'identité récente de votre enfant.
    </h3>

    <h3 v-if="route.name === 'reinscription-formulaire-cas-3'" class="texte_introduction">
      Ce formulaire vous permet de faire une demande de transport scolaire pour votre enfant scolarisé de la 6ème
      à la terminale.
    </h3>

    <div class="div_span_champ_oblig">
      <span
        v-if="
          [
            'formulaire-cas-1',
            'formulaire-cas-2',
            'formulaire-cas-3',
            'reinscription-formulaire-cas-1',
            'reinscription-formulaire-cas-2',
            'reinscription-formulaire-cas-3',
          ].includes(route.name)
        "
        class="span_champ_oblig"
      >
        * Merci de remplir les champs obligatoires
      </span>
    </div>
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router'
const route = useRoute()
</script>

<style lang="scss">
@import '../sass/app';

.bloc_introductif {
  margin: auto;
  text-align: center;
  background-color: #ead1e6;
  border-radius: 25px;
  padding: 4rem 2rem 4rem 2rem;

  .titre_introduction {
    font-weight: 900;
    letter-spacing: 1.5px;
  }

  .sous_titre_introduction {
    color: $thirdcolor;
    letter-spacing: 1.5px;
  }
}

.texte_introduction {
  color: $thirdcolor !important;
  font-size: 24px !important;
  margin-top: 1rem;
  text-align: center;
  margin-bottom: 2rem;
  @include media-breakpoint-up(lg) {
    padding: 0 10rem 0 10rem;
  }
}

.div_span_champ_oblig {
  display: flex;

  .span_champ_oblig {
    color: $danger;
    margin: auto;
  }
}
</style>